import { salesCobranzasEndpoints } from 'service/sources/sales/cobranzas'

const { axiosService } = require('service')

const exportClients = (origen, bloqueado) => {
  return axiosService.get(
    salesCobranzasEndpoints.EXPORT + '?bloqueado=' + bloqueado + '&origen=' + origen
  )
}

export const salesCobranzas = {
  exportClients,
}
